import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';

import { generateTraceParent } from './domain/traceparent-generator';

export const traceInterceptor: HttpInterceptorFn = (req, next) => {
  const windowRef = inject(WA_WINDOW);
  const traceparent = generateTraceParent(windowRef);

  const tracedReq = req.clone({
    setHeaders: {
      traceparent,
    },
  });

  return next(tracedReq);
};
